import React, { useState, lazy } from "react";
import { NavItem, Nav, Button } from "reactstrap";
import { NavLink, withRouter } from "react-router-dom";
import bgimage from "../../../assets/img/login/teamanics_logo_4.png";
import "../../../assets/css/dashboardstyle.css";
import "../../../assets/css/overridestyles.css";
import { logout } from "../../../services/AuthService";
import firebase from "firebase/compat/app";
import Header from "./header";
import search from "../../../../src/assets/img/searchcandidates/SearchCandidates.png";
import jobboardimage from "../../../../src/assets/img/jobboard/Jobboardimage.png";
const BasicInfo = (props) => {
  const handleLogout = () => {
    window.localStorage.setItem("isLogout", "yes");
    logout()
      .then((response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            firebase
              .auth()
              .signOut()
              .then(function () {
                window.localStorage.removeItem("user");
                window.localStorage.removeItem("account");
                //window.localStorage.removeItem("profile");
                window.localStorage.clear();
                sessionStorage.clear();
                window.location.href = "/";
              })
              .catch(function () {
                window.localStorage.clear();
                sessionStorage.clear();
                window.location.href = "/";
              });
          }
        } catch (err) {
          window.localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        }
      })
      .catch((error) => {
        firebase
          .auth()
          .signOut()
          .then(function () {
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("account");
            window.localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
          })
          .catch(function () {
            window.location.href = "/";
            window.localStorage.clear();
            sessionStorage.clear();
          });
      });
  };

  const showAdministrationLink = () => {
    const status = window.localStorage.getItem("userRole");
    if (status !== "TALENT_ADVISOR") return true;
    else return false;
  };

  return (
    <>
      <header className="bg-gradient-to-br from-primary-blue3 to-primary-blue min-sm:fixed top-0 w-screen max-sm:h-1/2 max-sm:-z-10 min-sm:h-16 shadow-primary-gray head_nav_z"></header>

      <div className="container">
        <Header />

        <div className="nav_wrapper ">
          <Nav>
            <NavItem className="min-sm:fixed flex flex-nowrap flex-shrink max-sm:justify-center max-sm:gap-2 min-sm:flex-col min-sm:top-16 min-sm:h-full min-sm:w-40   max-sm:fixed max-sm:bottom-0 max-sm:pt-3 max-sm:pb-5 max-sm:px-2 max-sm:w-screen bg-white shadow-lg text-xs text-Gray-600 text-center
              overflow-x-hidden scrollbar-thin overflow-y-scroll scrollbar-thumb-rounded
              ">
              <NavLink
                to={"/requests"}
                className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b "
              >
                <div className=" active py-8 min-sm:h-28 min-sm:inline-block ">
                  <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700 ">
                    <svg
                      className=" pb-1 mb-1 h-6 w-full min-sm:h-8"
                      viewBox="0 0 28 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.75 7.75V21.25H2.25V7.75H0.75ZM3.5 24H24.5V22.5H3.5V24ZM27.25 21.25V7.75H25.75V21.25H27.25ZM9 5H3.5V6.5H9V5ZM9.75 5.75V1.35H8.25V5.75H9.75ZM9.6 1.5H18.4V0H9.6V1.5ZM24.5 5H19V6.5H24.5V5ZM19 5H9V6.5H19V5ZM18.25 1.35V5.75H19.75V1.35H18.25ZM18.4 1.5C18.3172 1.5 18.25 1.43284 18.25 1.35H19.75C19.75 0.604415 19.1456 0 18.4 0V1.5ZM27.25 7.75C27.25 6.23122 26.0188 5 24.5 5V6.5C25.1904 6.5 25.75 7.05964 25.75 7.75H27.25ZM24.5 24C26.0188 24 27.25 22.7688 27.25 21.25H25.75C25.75 21.9404 25.1904 22.5 24.5 22.5V24ZM0.75 21.25C0.75 22.7688 1.98122 24 3.5 24V22.5C2.80964 22.5 2.25 21.9404 2.25 21.25H0.75ZM9.75 1.35C9.75 1.43284 9.68284 1.5 9.6 1.5V0C8.85442 0 8.25 0.604416 8.25 1.35H9.75ZM2.25 7.75C2.25 7.05964 2.80964 6.5 3.5 6.5V5C1.98122 5 0.75 6.23122 0.75 7.75H2.25Z"
                        fill="#333333"
                      />
                    </svg>
                    Job Requisitions
                  </span>
                </div>
              </NavLink>
              <NavLink
                to={"/accounts"}
                className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b"
              >
                <div className=" py-8 min-sm:h-28 min-sm:inline-block ">
                  <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                    <svg
                      className=" pb-1 mb-1 h-6 w-full min-sm:h-8"
                      viewBox="0 0 23 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 14V6.12353C21 5.9644 20.9368 5.81179 20.8243 5.69926L16.8007 1.67574C16.6882 1.56321 16.5356 1.5 16.3765 1.5H1.6C1.26863 1.5 1 1.76863 1 2.1V25.9C1 26.2314 1.26863 26.5 1.6 26.5H9.75"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6 11.5H16M6 6.5H11M6 16.5H9.75"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16 5.9V1.94194C16 1.69786 16.1979 1.5 16.4419 1.5C16.5592 1.5 16.6716 1.54656 16.7544 1.62944L20.8706 5.74556C20.9534 5.82844 21 5.94085 21 6.05806C21 6.30214 20.8021 6.5 20.5581 6.5H16.6C16.2686 6.5 16 6.23137 16 5.9Z"
                        fill="#333333"
                        stroke="#333333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.382 20.3916L17.5184 17.982C17.6643 17.6727 18.0857 17.6727 18.2316 17.982L19.368 20.3916L21.9094 20.7803C22.2355 20.8302 22.3654 21.2497 22.1294 21.4904L20.2908 23.3646L20.7247 26.0125C20.7804 26.3525 20.4394 26.6118 20.1476 26.4512L17.875 25.2004L15.6024 26.4512C15.3106 26.6118 14.9696 26.3525 15.0253 26.0125L15.4592 23.3646L13.6206 21.4904C13.3846 21.2497 13.5145 20.8302 13.8406 20.7803L16.382 20.3916Z"
                        stroke="#333333"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Accounts
                  </span>
                </div>
              </NavLink>

              <NavLink
                to={"/jobboard"}
                className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b"
              >
                <div className=" py-8 min-sm:h-28 min-sm:inline-block ">
                  <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                    <img
                      src={jobboardimage}
                      width="25"
                      height="20"
                      color="black"
                      className="mb-2"
                    ></img>{" "}
                    <br />
                    Job Boards
                  </span>
                </div>
              </NavLink>

              {showAdministrationLink() && (
                <NavLink
                  to={"/teammembers"}
                  className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b"
                >
                  <div className=" py-8 min-sm:h-28 min-sm:inline-block ">
                    <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                      <div className="simple-icon-people  pb-1 mb-1 h-6 w-full min-sm:h-8"></div>
                      Administration
                    </span>
                  </div>
                </NavLink>
              )}

              <NavLink
                to={"/searchcandidates"}
                className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b"
              >
                <div className=" py-8 min-sm:h-28 min-sm:inline-block ">
                  <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                    <img
                      src={search}
                      width="25"
                      height="20"
                      color="black"
                      className="mb-2"
                    ></img>{" "}
                    <br />
                    Search Candidates
                  </span>
                </div>
              </NavLink>

              <NavLink
                to={"/notifications"}
                className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b"
              >
                <div className=" py-8 min-sm:h-28 min-sm:inline-block ">
                  <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                    <svg
                      className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                      viewBox="0 0 24 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.5 9.5C19.5 7.37827 18.7098 5.34344 17.3033 3.84315C15.8968 2.34285 13.9891 1.5 12 1.5C10.0109 1.5 8.10322 2.34285 6.6967 3.84315C5.29018 5.34344 4.5 7.37827 4.5 9.5C4.5 18.8333 0.75 21.5 0.75 21.5H23.25C23.25 21.5 19.5 18.8333 19.5 9.5Z"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.1624 25.25C13.9426 25.6288 13.6272 25.9433 13.2477 26.1619C12.8682 26.3805 12.4379 26.4956 11.9999 26.4956C11.5619 26.4956 11.1316 26.3805 10.7521 26.1619C10.3726 25.9433 10.0572 25.6288 9.8374 25.25"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Notifications
                  </span>
                </div>
              </NavLink>

              <NavLink
                onClick={() => handleLogout()}
                to={"/log"}
                className="min-sm:hover:bg-slate-100 min-sm:border-blue-200 min-sm:border-b"
              >
                <div className="py-8 min-sm:h-28 min-sm:inline-block ">
                  <span className=" hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 23 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.467 6.90449C14.7355 6.636 15.1708 6.636 15.4393 6.90449L19.0486 10.5139C19.3171 10.7823 19.3171 11.2177 19.0486 11.4861L15.4393 15.0955C15.1708 15.364 14.7355 15.364 14.467 15.0955C14.1985 14.827 14.1985 14.3917 14.467 14.1232L17.5902 11L14.467 7.87676C14.1985 7.60828 14.1985 7.17297 14.467 6.90449Z"
                        fill="black"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.25 11C8.25 10.6203 8.5578 10.3125 8.9375 10.3125H18.5625C18.9422 10.3125 19.25 10.6203 19.25 11C19.25 11.3797 18.9422 11.6875 18.5625 11.6875H8.9375C8.5578 11.6875 8.25 11.3797 8.25 11Z"
                        fill="black"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.15273 3.15273C3.41059 2.89487 3.76033 2.75 4.125 2.75H8.9375C9.3172 2.75 9.625 3.0578 9.625 3.4375C9.625 3.8172 9.3172 4.125 8.9375 4.125L4.125 4.125L4.125 17.875H8.9375C9.3172 17.875 9.625 18.1828 9.625 18.5625C9.625 18.9422 9.3172 19.25 8.9375 19.25H4.125C3.76033 19.25 3.41059 19.1051 3.15273 18.8473C2.89487 18.5894 2.75 18.2397 2.75 17.875V4.125C2.75 3.76033 2.89487 3.41059 3.15273 3.15273Z"
                        fill="black"
                      ></path>
                    </svg>
                    Logout
                  </span>
                </div>
              </NavLink>

              <div className=" p-2 t-poweredby-margin">
                <span className="t-font-italic"> Powered By</span>

                <a className="menu-button d-none d-md-block " href="/">
                  <img alt="hero" src={bgimage} />
                </a>
              </div>
            </NavItem>
          </Nav>
        </div>
      </div>
    </>
  );
};

export default withRouter(BasicInfo);
